import React, {useEffect} from "react";
import Nav from "../components/main/nav";
import {Link} from "react-router-dom";
import image_footer from "../components/img/orocash_bicolor.png";

const Politicas = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Nav/>
            <div className="container mt-5 pt-5" id="section">
                <div className="row mt-4">
                    <div className="col-md-12">
                        <h4>Cláusula de consentimiento</h4>
                    </div>

                    <div className="col-md-3 col-sm-12 col-xs-12 mt-4">
                        <ul class="list-group">
                            <li class="list-group-item" style={{
                                backgroundColor: "rgb(2, 66, 121)",
                                color: "#fff",
                            }}>
                                {" "}
                                <Link to="/politicas" style={{
                                    color: "#fff",
                                }}>Cláusula de consentimiento</Link>
                            </li>
                            {/*<li*/}
                            {/*    class="list-group-item"*/}

                            {/*>*/}
                            {/*    <Link to="/terminos" style={{*/}
                            {/*        color: "black",*/}
                            {/*    }}>Términos y condiciones</Link>*/}
                            {/*</li>*/}
                        </ul>
                    </div>

                    <div className="col mt-4 card">
                        <div className="card-body">
                            <h5 className="text-justify mt-3">
                                CLÁUSULA DE CONSENTIMIENTO PARA EL TRATAMIENTO DE DATOS PERSONALES EN PROCESOS DE SELECCIÓN - GRUPO OROCASH
                            </h5>
                            <p class="text-justify mt-3">
                                Al presentar su postulación a un puesto de trabajo en cualquiera de las empresas que
                                conforman el <strong>Grupo Orocash</strong>, usted está a punto de proporcionarnos sus datos
                                personales. En cumplimiento de la Ley Orgánica de Protección de Datos Personales
                                (LOPDP) de Ecuador y su Reglamento, le informamos sobre cómo trataremos su
                                información.
                            </p>
                            <br/>
                            <p><strong>1. Responsable del Tratamiento</strong>: Las empresas que conforman el Grupo Orocash (en adelante, "EL GRUPO"), con domicilio en Guayaquil, actuarán como responsables conjuntos del tratamiento de sus datos personales. Esto significa que su información podrá ser compartida y evaluada por las distintas empresas del grupo con fines de selección.</p>
                            <br/>
                            <p><strong>2. Finalidad del Tratamiento de sus Datos: </strong>Sus datos personales serán tratados con las siguientes finalidades:</p>
                            <br/>
                            <div className="pl-5">
                                <li>
                                    <ul><strong>Gestión del Proceso de Selección: </strong>Evaluar su perfil profesional y académico para la vacante a la que postula.</ul>
                                </li>
                                <li>
                                    <ul><strong>Verificación de Información: </strong>Comprobar la veracidad de los datos proporcionados, incluyendo la validación de referencias laborales y académicas.</ul>
                                </li>
                                <li>
                                    <ul><strong>Comunicación: </strong>Contactarle para coordinar entrevistas, pruebas psicométricas o técnicas y comunicarle los resultados del proceso.</ul>
                                </li>
                                <li>
                                    <ul><strong>Creación de un Perfil de Candidato: </strong>Generar un perfil interno que facilite la evaluación de su idoneidad para el puesto.</ul>
                                </li>
                                <li>
                                    <ul><strong>(Opcional) Inclusión en la Base de Talentos: </strong>Conservar su información para considerarle en futuras vacantes que se ajusten a su perfil dentro de cualquiera de las empresas de EL GRUPO.</ul>
                                </li>
                            </div>
                            <br/>
                            <p><strong>3. Base Legal para el Tratamiento: </strong>El tratamiento de sus datos se basa en su consentimiento libre, específico, informado e inequívoco, otorgado al aceptar esta cláusula, de conformidad con el Art. 7, numeral 1 de la LOPDP.</p>
                            <br/>
                            <p><strong>4. Datos Personales que Trataremos: </strong>Recopilaremos los datos que usted nos proporcione a través de su hoja de vida, formulario de postulación y durante las entrevistas, tales como: datos de identificación, datos de contacto, fotografía, formación académica, experiencia profesional, referencias y cualquier otra información relevante para la evaluación de su candidatura.
                                No trataremos datos sensibles a menos que sea estrictamente necesario y contemos con su consentimiento explícito.</p>
                            <br/>
                            <p><strong>5. Plazo de Conservación de los Datos: </strong></p>
                            <div className="pl-5">
                                <li>
                                    <ul>Si su postulación <strong>no resulta en una contratación</strong>, sus datos personales serán conservados en nuestra base de talentos por un período máximo de <strong>dos (2) años</strong> para futuras oportunidades laborales, siempre que usted lo autorice expresamente en la sección de consentimiento. Transcurrido este plazo, o si usted revoca su consentimiento, sus datos serán eliminados de forma segura.</ul>
                                </li>
                                <li>
                                    <ul>Si usted <strong>es contratado</strong>, sus datos pasarán a formar parte de su expediente laboral y se regirán por las políticas de protección de datos para empleados.</ul>
                                </li>
                            </div>
                            <br/>
                            <p><strong>6. Sus Derechos como Titular: </strong>Usted tiene derecho a:</p>
                            <div className="pl-5">
                                <li>
                                    <ul><strong>Acceder</strong> a sus datos personales.</ul>
                                </li>
                                <li>
                                    <ul><strong>Rectificar y actualizar</strong> su información si es inexacta o está incompleta.</ul>
                                </li>
                                <li>
                                    <ul><strong>Eliminar</strong> sus datos cuando ya no sean necesarios para los fines indicados.</ul>
                                </li>
                                <li>
                                    <ul><strong>Oponerse</strong> al tratamiento de sus datos por razones legítimas.</ul>
                                </li>
                                <li>
                                    <ul>Solicitar la <strong>portabilidad</strong> de sus datos.</ul>
                                </li>
                                <li>
                                    <ul><strong>Revocar su consentimiento</strong> en cualquier momento.</ul>
                                </li>
                            </div>
                            <br/>

                            <p>Para ejercer sus derechos, puede enviar una solicitud al correo electrónico: <strong>sgonzalez@orocash.ec o dpd@orocash.ec</strong>.</p>
                            <br/><br/>
                            <h5>DECLARACIÓN DE CONSENTIMIENTO</h5>
                            <br/>
                            <p>Al marcar las siguientes casillas, usted declara haber leído, comprendido y aceptado los términos aquí expuestos:</p>
                            <br/>
                            <p><strong>☐ Consiento y autorizo</strong> de manera libre, específica, informada e inequívoca a las empresas del <strong>Grupo Orocash</strong> para que traten mis datos personales con el fin de evaluar mi candidatura para la vacante a la que postulo, de acuerdo con lo descrito en esta cláusula.</p>
                            <br/>
                            <p><strong>☐ (Opcional) Autorizo expresamente</strong> a las empresas del <strong>Grupo Orocash</strong> a conservar mis datos personales en su base de talentos por un período de dos (2) años para ser considerado/a en futuros procesos de selección que se ajusten a mi perfil. Entiendo que puedo revocar esta autorización en cualquier momento.</p>
                        </div>
                    </div>
                </div>
            </div>
            <footer class="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 footer-content">
                            <div className="footer-colm-1">
                                {/*eslint-disable-next-line*/}
                                <img src={image_footer} width={250}/>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 footer-content">
                            <div className="footer-colm-2">
                                <h5 class="footer-colm-title">Nosotros</h5>
                                <ul class="footer-nav">
                                    {/*<li>*/}
                                    {/*    /!* eslint-disable-next-line *!/*/}
                                    {/*    <a href="#">Quiénes somos</a>*/}
                                    {/*</li>*/}
                                    <li>
                                        {/* eslint-disable-next-line */}
                                        <a href="#">Contáctenos</a>
                                    </li>
                                    <li>
                                        {/* eslint-disable-next-line */}
                                        <a href="#"></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 footer-content">
                            <div className="footer-colm-3">
                                <h5 class="footer-colm-title">Soporte</h5>
                                <ul class="footer-nav">
                                    {/*<li>*/}
                                    {/*    <Link to="/terminos">Términos y condiciones</Link>*/}
                                    {/*</li>*/}
                                    <li>
                                        <Link to="/politicas">Cláusula de consentimiento</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 footer-content">
                            <div className="footer-colm-4 footer-subscribe">
                                <h5 class="footer-colm-title">Información de contacto</h5>

                                <p>
                                    <a href="mailto:contactenos@orocash.com">
                                        contactenos@orocash.com
                                    </a>
                                </p>
                                <p>
                                    <a href="tel:+5930994480427">+5930994480427</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="border-shadow-2"></div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="copyright-text text-center">
                                <p>OROCASH © {new Date().getFullYear()}</p>
                                <p>
                                    {/* eslint-disable-next-line */}
                                    Designed by <a href="#">Innode.</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Politicas;
